import { useContext, useEffect } from "react";
import { CardContext, SocketContext, TeamContext, UserContext } from "../../../context";
import { ICard, IPlayer } from "../../../interfaces";
import { MainButton } from "../../atoms";
import { ChallengeCardReadOnly, SolutionCardReadOnly, StrengthCardReadOnly } from "../../molecules";
import { useSound } from "../../../hooks";
import whiteArrow from "../../../assets/icons/white_arrow.svg";
import { useTranslation } from "react-i18next";

const RenderSelectedCardsCelebration = () => {
    const { t } = useTranslation();
    const { nextPhaseConffeti, setTheSolutionCardSelectedByDilemmaOwner } = useContext(SocketContext);
    const { userData } = useContext(UserContext);
    const { game } = useContext(TeamContext);
    const { setDataOfDoubleClickedSolutionCard } = useContext(CardContext);
    const isTheUserDilemmaOwner = userData?.email === game?.gameInfo.currentPlayerEmail || "";
    const dilemmaOwner = game?.players.find((player: IPlayer) => { return player.email === game?.gameInfo.currentPlayerEmail });
    const dilemmaOwnerNickname = dilemmaOwner?.nickname || "";
    const dilemmaOwnerColor = dilemmaOwner?.color || "pink";
    const spinOwner = game?.players.find((player: IPlayer) => { return player.email === game?.gameInfo.currentSpinOwner });
    const spinOwnerNickname = spinOwner?.nickname || "";
    const spinOwnerColor = spinOwner?.color || "blue";
    const {playSound} = useSound();

    useEffect(() => {
        playSound("/sounds/PositiveAlert3.mp3");
        setDataOfDoubleClickedSolutionCard(undefined);
        setTheSolutionCardSelectedByDilemmaOwner(undefined);

    }, [playSound, setDataOfDoubleClickedSolutionCard, setTheSolutionCardSelectedByDilemmaOwner])
    
    const switchPhaseToTheNextOne = () => {
        nextPhaseConffeti(1);
    }

    let strengthCardData: ICard | undefined = game?.gameInfo?.solutionChosenGameState?.strengthCard;
    if (!strengthCardData) {
        return (<div></div>)
    }

    let solutionCardData: ICard | undefined = game?.gameInfo?.solutionChosenGameState?.solutionCard;
    if (!solutionCardData) {
        return (<div></div>)
    }

    let questionCardData: ICard | undefined = game?.gameInfo?.solutionChosenGameState?.questionCard;
    if (!questionCardData) {
        return (<div></div>)
    }

    const renderSelectedCardsCelebrationLowerText = () => {
        if (isTheUserDilemmaOwner) {
            return (
                <div className="explain_your_choice_text animation_ripple animation_ripple_delay_16">
                    <div>
                        <span className={`text_color_${dilemmaOwnerColor}`}>{dilemmaOwnerNickname}</span> {t("commaText")} {t("userName_ExplainHowYouWillUseThisStrengthText")} {t("commaText")}
                    </div>
                    <div> {t("andClickOnTheButtonWhenYouAreDoneText")} </div>
                </div>
            )
        }

        return (
            <div className="explain_your_choice_text animation_ripple animation_ripple_delay_16" style={{ margin: "8vh 0"}}>
                <div>
                    {t("let_userName_Text")} <span className={`text_color_${dilemmaOwnerColor}`}>{dilemmaOwnerNickname}</span> {t("userName_explainTheDecisionText")}
                </div>
                <div>  </div>
            </div>
        )
    }

    return (
        <div className="full_screen render_selected_cards_celebration">

            <div className="selected_cards_celebration_title">
                <div className="title_small animation_ripple animation_ripple_delay_2"> {t("theDilemmaIsSolvedText")} </div>
                <div className="title_big animation_ripple animation_ripple_delay_4"> <span className={`text_color_${dilemmaOwnerColor}`}>{dilemmaOwnerNickname}</span> {t("userName_chose_otherPlayerSolutionText")} <span className={`text_color_${spinOwnerColor}`}>{spinOwnerNickname}</span>{t("userName_solutionText")} </div>
            </div>

            <div className="gradient_line_holder center_horizontally_and_vertically animation_ripple animation_ripple_delay_6">
                <div className="linear_gradient_line_horizontal" style={{ width: "50%" }}></div>
            </div>

            <div className="selected_cards_celebration_body">
                <div className="selected_cards_wrapper">
                    <div className="chosen_strength_card_holder">
                        <div className="card_read_only_wrapper_celebration animation_ripple animation_ripple_delay_8">
                            <ChallengeCardReadOnly cardData={questionCardData} />
                        </div>
                    </div>
                    <img className="white_arrow animation_ripple animation_ripple_delay_10" src={whiteArrow} alt="white arrow" />
                    <div className="chosen_solution_and_action_cards_holder">
                        <div className="solution_card animation_ripple animation_ripple_delay_12">
                            <div className="card_read_only_wrapper_celebration">
                                <StrengthCardReadOnly cardData={strengthCardData} />
                            </div>
                        </div>
                        <div className="question_card">
                            <div className="card_read_only_wrapper_celebration animation_ripple animation_ripple_delay_14">
                                <SolutionCardReadOnly cardData={solutionCardData} />
                            </div>
                        </div>
                    </div>
                </div>

                {renderSelectedCardsCelebrationLowerText()}

                <div className="button_holder animation_ripple animation_ripple_delay_18">
                    {isTheUserDilemmaOwner && <MainButton type="big" text={t("doneText")} clickHandler={() => switchPhaseToTheNextOne()} disabled={false} />}
                </div>
            </div>

        </div>
    )
}

export default RenderSelectedCardsCelebration;